<template>
  <div ref="dropDownRef" v-on-click-outside="onClickOutsideHandler">
    <div class="relative space-y-1">
      <div>
        <slot
          name="action"
          v-bind="{
            open,
            close,
            isVisible,
          }"
        ></slot>
      </div>
      <Transition
        leave-active-class="transform transition duration-300 ui-drop-down-animation"
        leave-to-class="-translate-y-1/2 scale-y-0 opacity-0"
      >
        <div v-show="isVisible" class="absolute left-0 right-0">
          <slot
            v-bind="{
              open,
              close,
              isVisible,
            }"
          ></slot>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { vOnClickOutside } from '@vueuse/components';
  import type { OnOutsideClickHandler } from '@shared/types';

  const emit = defineEmits<{
    onClickOutside: [];
  }>();

  const isVisible = ref(false);
  const dropDownRef = ref();

  const open = () => {
    isVisible.value = true;
  };

  const close = () => {
    isVisible.value = false;
  };

  const onClickOutside = () => {
    close();
    emit('onClickOutside');
  };

  const onClickOutsideHandler: OnOutsideClickHandler = [
    onClickOutside,
    { ignore: [dropDownRef] },
  ];
</script>

<style scoped>
  .ui-drop-down-animation {
    transition-timing-function: cubic-bezier(0.61, -0.53, 0.43, 1.43);
  }
</style>
